import { styled } from '@stitches/react';

export const Header = styled('h2', {
  fontSize: '1.5rem',
  lineHeight: '1.5rem',
  color: '$lupine-950',
  fontWeight: '500',
});

export const SubHeader = styled('h3', {
  fontSize: '1.25rem',
  fontWeight: '500',
  color: '$lupine-950',
});

export const Paragraph = styled('p', {
  color: '$lupine-950',
});

export const List = styled('ul', {
  color: '$lupine-950',
  listStyleType: 'disc',
  paddingLeft: '24px',
});

export const ListItem = styled('li', {
  marginBottom: '12px',
});

export const EmailLink = styled('a', {
  color: '$lupine-950',
  textDecoration: 'none',
});
